import { Loader } from "@launchmetrics/lm-ui";
import Breadcrumb from 'components/LM/common/Breadcrumb';
import { Button, ButtonToolbar, Card, Form } from 'react-bootstrap';
import './voicemsearch.scss';

function VoiceMSearchForm(props) {
  return (
    <div className="voices-search-form">
      <Form>
      <Breadcrumb items={['Voices', 'Mass Search']}/>
        <Card>
          <Card.Header>
            <Card.Title tag="h5">
              Enter a list of search terms here, one term per line
            </Card.Title>
            <h6 className="card-subtitle text-muted">
              A search term can be a voice ID, or a voice name, or a social profile
            </h6>
          </Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="inSearchProfiles">
              <Form.Control
                as="textarea"
                rows="10"
                disabled={props.processing}
                onChange={(ev) => props.onChange(ev)}
                value={props.query ?? ''}
              />
            </Form.Group>
            <ButtonToolbar>
              <Button
                color="primary"
                type="submit"
                className="mr-1 mb-1"
                disabled={props.processing || !props.query || !props.query.length}
                onClick={(ev) => props.onSubmit(ev)}
              >
                Submit
                {props.processing && <Loader styleProps={{ marginLeft: '10px'}}size={20} />}
              </Button>
            </ButtonToolbar>
          </Card.Body>
        </Card>
      </Form>
    </div>
  )
}

export default VoiceMSearchForm;
